
//37
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "Badge3867810342",
    {"root":"Badge3867810342--root"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/deprecated/stylable-badge/Badge.st.css
// module id = 513
// module chunks = 0